export default "__VITE_ASSET__BM1p456x__"